'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "@/components/ui/carousel";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import VirtualTourList from "./virtual-tour-list";
import { useEffect, useState } from "react";

export interface UnitTypeTowerProps {
  title: string;
  specifications: {
    id: string;
    label: string;
    short_label: string;
    unit: string;
    area: string;
    image: string[];
    facility: {
      id: string;
      label: string;
      icon: string;
    }[];
    map: string;
    mini_map: string;
    virtual_tour_link: string;
  }[];
}

export default function UnitTypeTower(props: UnitTypeTowerProps) {
  const virtualTourProps = props.specifications.map((spec) => ({
    id: spec.id,
    title: spec.short_label,
    link: spec.virtual_tour_link,
  }));

  const [specActive, setspecActive] = useState(props.specifications[0]?.id)

  useEffect(() => {
    if(!window.location.hash)return
    
    const element = document.querySelector(window.location.hash);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    setspecActive(props.specifications[0]?.id)
  }, [props.specifications[0]?.id])
  
  return (
    <>
      <div className="bg-coffebrown pt-10 xl:pt-20">
        <div className="w-full xl:max-w-screen-lg mx-auto px-10 xl:px-0">
          <h3
            className="xl:text-5xl text-white text-center font-pluto"
            dangerouslySetInnerHTML={{ __html: props.title }}
          ></h3>

          <Tabs
            value={specActive}
             onValueChange={setspecActive}
            className="mt-2 xl:mt-14"
          >
            <TabsList className="bg-transparent flex w-full">
              {props.specifications.map((spec) => {
                return (
                  <TabsTrigger
                    key={spec.id}
                    className="text-white flex-1 pb-4 text-[10px] xl:text-xl cursor-pointer font-pluto"
                    value={spec.id}
                  >
                    {spec.label}
                  </TabsTrigger>
                );
              })}
            </TabsList>
            {props.specifications.map((spec) => {
              const [nett, semi_gross] = spec.area.split("/");
              return (
                <TabsContent key={spec.id} value={spec.id}>
                  <div className="mt-2 xl:mt-6">
                    <Carousel className="w-full">
                      <CarouselContent>
                        {spec.image.map((image, index) => {
                          return (
                            <CarouselItem key={index} className="relative">
                              <img
                                src={image}
                                className="rounded-[9px] xl:rounded-[20px] w-full object-cover h-[261px] xl:h-[530px]"
                              />
                            </CarouselItem>
                          );
                        })}
                      </CarouselContent>
                      <CarouselPrevious className="size-[22px] xl:size-10 left-5 xl:left-10 bg-transparent text-white z-10 border-2 !border-white" />
                      <CarouselNext className="size-[22px] xl:size-10 right-5 xl:right-10 bg-transparent text-white z-10 border-2 border-white" />
                    </Carousel>

                    <div className="flex flex-col-reverse xl:flex-row mt-4 xl:mt-14">
                      <div className="w-full xl:flex-1 inline-flex xl:justify-center mt-6 xl:mt-0">
                        <img
                          src={spec.map}
                          loading="lazy"
                          alt=""
                          className="object-contain object-top xl:h-full w-full"
                        />
                      </div>
                      <div className="w-full xl:flex-1 xl:ml-12">
                        <p className="text-white text-[12px] xl:text-2xl font-medium">
                          {spec.unit}
                        </p>

                        <div className="hidden xl:block">
                          <p className="text-white font-medium font-pluto xl:text-3xl">
                            <span className="xl:text-4xl">{semi_gross}</span>{" "}
                            sqm
                          </p>
                          <p className="text-white text-[10px] xl:text-2xl font-medium">
                            Semi gross
                          </p>
                        </div>

                        <div className="block xl:hidden">
                          <p className="text-white font-medium font-pluto xl:text-3xl">
                            <span className="xl:text-4xl">{semi_gross}</span> sqm
                          </p>
                          <p className="text-white text-[10px] xl:text-2xl font-medium">
                          Semi gross

                          </p>
                        </div>

                        <div className="flex flex-col-reverse xl:flex-col">
                          <div className="basis-2/5">
                            <img
                              src={spec.mini_map}
                              alt=""
                              loading="lazy"
                              className="w-[200px] h-[200px] object-contain"
                            />
                          </div>

                          <div className="grid xl:grid-rows-3 grid-cols-3 xl:grid-cols-2 xl:[grid-auto-flow:column] gap-2.5 w-full xl:w-fit flex-1">
                            {spec.facility.map((facility) => {
                              return (
                                <div
                                  key={facility.id}
                                  className="inline-flex items-center flex-1/2"
                                >
                                  <img
                                    src={facility.icon}
                                    alt="bedroom"
                                    width={52}
                                    height={52}
                                    loading="lazy"
                                    className="w-8 xl:w-14 h-8 xl:h-14 object-cover"
                                  />
                                  <p className="text-white font-medium ml-1.5 xl:ml-5 text-[10px] xl:text-2xl">
                                    {facility.label}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabsContent>
              );
            })}
          </Tabs>
        </div>

        <div className="px-10 xl:px-0 bg-linen">
          <VirtualTourList content={virtualTourProps} />
        </div>
      </div>
    </>
  );
}
